export const courierName = (key) => {
  switch (String(key)) {
    case "THP":
      return {name: "EMS"};
    case "CJLX":
      return {name: "CJLogisticShopX"};
    case "FLE":
      return {name: "Flash Express"};
    case "FLEWP":
      return {name: "Flash Express (FLEWP)"};
    case "FLEB":
      return {name: "Flash Express Bulky"};
    case "FLEF":
      return {name: "Flash Express Fruit"};
    case "FLEDS":
      return {name: "Flash Dropoff"};
    case "SCG":
      return {name: "SCG Express"};
    case "JNT":
      return {name: "JAndTExpress"};
    case "JNTD":
      return {name: "JAndTExpressDropOff"};
    case "ECP":
      return {name: "eCo-Post"};
    case "TRUE":
      return {name: "True e-Logistic"};
    case "BEE":
      return {name: "BEE Express"};
    case "NJV":
      return {name: "Ninjavan"};
    case "SCGC":
      return {name: "SCG Yamato Express Chilled"};
    case "SCGF":
      return {name: "SCG Yamato Express Frozen"};
    case "TP2":
      return {name: "Thaipost Registered"};
    case "EMST":
      return {name: "EMS W-ST"};
    case "EMSX":
      return {name: "EMSX"};
    case "EMSW":
      return {name: "EMS (Warp)"};
    case "BEST":
      return {name: "BEST Express"};
    case "TPSD":
      return {name: "Teleport"};
    case "MSE":
      return {name: "Makesend Express"};
    case "MSEC":
      return {name: "Makesend Express Chilled"};
    case "MSEF":
      return {name: "Makesend Express Frozen"};
    case "SPE":
      return {name: "Shippop Express"};
    case "SPEC":
      return {name: "Shippop Express Cool"};
    case "KRYS":
      return {name: "Kerry Express"};
    case "KRYQ":
      return {name: "Quick Express"};
    case "ORNG":
      return {name: "Orange Express"};
    case "EMSXP":
      return {name: "SPRESS"};
    case "DHL":
      return {name: "DHL Express (Eco)"};
    case "XPSO":
      return {name: "Xpresso"};
    case "XPSD":
      return {name: "Xpresso (Sameday)"};
    case "SPXP":
      return {name: "ShopeeXpress"};
    case "CRARMPPX":
      return {name: "Aramex Priority (Parcel)"};
    case "CRARMPDX":
      return {name: "Aramex Priority (Document)"};
    case "CRTPEP":
      return {name: "ThailandPost ePacket"};
    case "CRTPEWD":
      return {name: "EMS World (Document)"};
    case "CRTPEWP":
      return {name: "EMS World (Package)"};
    default:
      return {name: ""};
  }
};

export const courierList = [
  {value: "THP", text: "EMS"},
  {value: "CJLX", text: "CJLogisticShopX"},
  {value: "FLE", text: "Flash Express"},
  {value: "FLEB", text: "Flash Express Bulky"},
  {value: "FLEF", text: "Flash Express Fruit"},
  {value: "FLEDS", text: "Flash Dropoff"},
  {value: "SCG", text: "SCG Express"},
  {value: "JNT", text: "JAndTExpress"},
  {value: "JNTD", text: "JAndTExpressDropOff"},
  {value: "ECP", text: "eCo-Post"},
  {value: "BEE", text: "BEE Express"},
  {value: "NJV", text: "Ninjavan"},
  {value: "SCGC", text: "SCG Yamato Express Chilled"},
  {value: "SCGF", text: "SCG Yamato Express Frozen"},
  {value: "TP2", text: "Thaipost Registered"},
  {value: "EMST", text: "EMS W-ST"},
  {value: "EMSW", text: "EMSW"},
  {value: "EMSX", text: "EMSX"},
  {value: "BEST", text: "BEST Express"},
  {value: "TPSD", text: "Teleport"},
  {value: "MSE", text: "Makesend Express"},
  {value: "MSEC", text: "Makesend Express Chilled"},
  {value: "MSEF", text: "Makesend Express Frozen"},
  {value: "SPE", text: "Shippop Express"},
  {value: "SPEC", text: "Shippop Express Cool"},
  {value: "KRYS", text: "Kerry Express"},
  {value: "KRYQ", text: "Quick Express"},
  {value: "ORNG", text: "Orange Express"},
  {value: "EMSXP", text: "SPRESS"},
  {value: "DHL", text: "DHL Express (Eco)"},
  {value: "SPXP", text: "ShopeeXpress"},
  {value: "XPSO", text: "Xpresso"},
  {value: "XPSD", text: "Xpresso (Sameday)"},
  {value: "CRARMPPX", text: "Aramex Priority (Parcel)"},
  {value: "CRARMPDX", text: "Aramex Priority (Document)"},
  {value: "CRTPEP", text: "ThailandPost ePacket"},
  {value: "CRTPEWD", text: "EMS World (Document)"},
  {value: "CRTPEWP", text: "EMS World (Package)"},
];
